import classNames from "classnames"
import Button, { ButtonV2 } from "components/Button"
import { Input } from "components/Input"
import { Navbar } from "components/Navbar"
import { useUser } from "hooks/user"
import { Userv2 } from "models/user"
import Head from "next/head"
import { PropsWithChildren, useEffect, useId, useState } from "react"
import { FormField } from 'components/Form'
import Footer from "components/Footer"
import { useMutation } from "react-query"
import { useAPIFetch } from "hooks/fetch"
import { VERIFICATION_FORM_ENDPOINT } from "api/endpoints"
import { toast } from "react-toastify"
import { handleFetchError } from "utils/fetch"
import { genericToastErrorMessage } from "lib/errors"
import ReactSelect from "react-select"
import { spheresOfExpertise, spheresOfExpertiseOptions, spheresOfExpertiseTreeData } from "data/expertise"
import { TreeSelect, Button as AntdButton } from "antd"
import { SwitcherOutlined } from "@ant-design/icons"
import { Tree } from "antd"
import { ErrorWrapper } from "components/ErrorWrapper"


function Benefit({ icon, name, children }: PropsWithChildren<{ icon: string, name: string }>) {
  return <div className="flex flex-row gap-1 items-start">
    <img src={icon} width={24 * 3} height={24 * 3} />
    <div>
      <h2 className="text-md font-semibold">{name}</h2>
      <p className="mt-0.5 max-w-[400px] 4xl:max-w-[500px]">{children}</p>
    </div>
  </div>
}


type VerificationFormPayload = {
  first_name: string
  second_name: string
  middle_name: string
  email: string
  nickname: string
  spheres_of_expertise: string[]
  author_id: string
  spin: string
  orcid?: string
  publications?: string[]
}

function VerificationForm({ user, onSubmit }: { user?: Userv2; onSubmit?: (d: VerificationFormPayload) => any }) {
  const [personalData, setPersonalData] = useState<boolean>(false)
  const [localSpheresOfExpertise, setLocalSpheresOfExpertise] = useState<string[]>([])
  const [skipOrcid, setSkipOrcid] = useState(false)
  const [publications, setPublications] = useState<string[]>([])
  const [errors, setErrors] = useState<Record<string, string>>({})
  // const [sphereOfExpertise, setSphereOfExpertise] = useState<string>()

  useEffect(() => {
    if (user) setLocalSpheresOfExpertise(user.bio?.spheres_of_expertise ?? [])
  }, [user])
  return <div className="rounded-lg border border-light-grey p-3 flex flex-row gap-3">
    <div className="flex-1 flex flex-col gap-1 max-w-20">
      <h2 className="text-2xl font-semibold">Подтверждение квалификации</h2>
      <p>Чтобы начать взаимодействие с&nbsp;авторами и&nbsp;редакторами, заполните простую форму верификации на&nbsp;нашей платформе, отправив Ваши персональные данные и сферу экспертизы.</p>
    </div>
    <form className="flex flex-col gap-2" onSubmit={e => {
      e.preventDefault()

      const lerrs: Record<string, string> = {}
      if (localSpheresOfExpertise.length < 1) {
        lerrs['spheresOfExpertise'] = 'Выберите сферу хотя бы одну сферу экспертизы'
      }

      if (publications.length < 3) {
        lerrs['publications'] = 'Требуется указать 3 и более публикаций'
      }

      if (Object.keys(lerrs).length > 0) {
        setErrors(lerrs)
        return
      }


      const formData = new FormData(e.currentTarget)
      onSubmit?.({
        first_name: user?.first_name ?? formData.get('first_name') as string,
        second_name: user?.second_name ?? formData.get('second_name') as string,
        middle_name: user?.middle_name ?? formData.get('middle_name') as string,

        nickname: user?.nickname ?? formData.get('nickname') as string,
        email: user?.bio?.corporate_email ?? formData.get('email') as string,
        spheres_of_expertise: localSpheresOfExpertise ?? user?.bio?.spheres_of_expertise,
        author_id: user?.bio?.author_id ?? formData.get('author_id') as string,
        spin: user?.bio?.spin ?? formData.get('spin') as string,
        orcid: user?.bio?.orcid ?? (skipOrcid ? undefined : formData.get('orcid') as string),

        publications: publications,
      })

    }}>
      <div className="flex flex-row gap-1">
        <FormField name="Имя" required>
          {user?.first_name ? <Input disabled value={user.first_name} name="first_name" /> : <Input placeholder="Имя" name="first_name" required />}
        </FormField>
        <FormField name="Фамилия" required>
          {user?.second_name ? <Input disabled value={user.second_name} name="second_name" /> : <Input placeholder="Фамилия" name="second_name" required />}
        </FormField>
      </div>
      <div className="flex flex-row gap-1">
        <FormField name="Отчество" required>
          {user?.middle_name ? <Input disabled value={user.middle_name} name="middle_name" /> : <Input placeholder="Отчество" name="middle_name" required />}
        </FormField>
        <FormField name="Имя пользователя" required>
          {user?.nickname ? <Input disabled value={user.nickname} name="nickname" /> : <Input placeholder="Имя пользователя" name="nickname" required />}
        </FormField>
      </div>
      <FormField name="Почта" required className="w-full">
        {user?.bio?.corporate_email ? <Input disabled value={user.bio.corporate_email} className="w-full" name="email" /> : <Input placeholder="Почта" name="email" className="w-full" required />}
      </FormField>
      {/* <FormField name="Сферы экспертизы" required> */}
      {/*   <ReactSelect */}
      {/*     // tooltip="Стиль" */}
      {/*     required */}
      {/*     value={localSpheresOfExpertise.map(v => ({ label: v, value: v }))} */}
      {/*     options={spheresOfExpertiseOptions} */}
      {/*     onChange={selected => { */}
      {/*       setLocalSpheresOfExpertise(selected.map(v => v.value!)) */}
      {/*     }} */}
      {/*     isOptionDisabled={option => !!option.isDisabled} */}
      {/*     isMulti */}
      {/*     placeholder="Выберите сферы Вашей экспертизы" */}
      {/*     styles={{ */}
      {/*       placeholder: (base, state) => ({ */}
      {/*         ...base, */}
      {/*         color: 'var(--color-grey)', */}
      {/*       }), */}
      {/*       control: (base, state) => ({ ...base, borderRadius: 5 }) */}
      {/*     }} */}
      {/*     className="mt-1" */}
      {/*   /> */}


      {/* </FormField> */}


      <FormField name="Сферы экспертизы" required>
        <ErrorWrapper error={errors['spheresOfExpertise']}>
          {/* {JSON.stringify(spheresOfExpertiseTreeData)} */}
          <TreeSelect
            // open={true}
            style={{ width: '100%', maxWidth: 650 }}
            value={localSpheresOfExpertise}
            placeholder="Выберите сферы Вашей экспертизы"
            multiple
            onChange={v => setLocalSpheresOfExpertise(v)}
            treeData={spheresOfExpertiseTreeData} />
        </ErrorWrapper>
      </FormField>

      <div className="flex flex-row gap-1">
        <FormField name="Author ID">
          {user?.bio?.author_id ? <Input disabled value={user.bio.author_id} className="w-full" name="author_id" /> : <Input placeholder="000000" pattern="[0-9]+" name="author_id" className="w-full" />}
        </FormField>
        <FormField name="SPIN">
          {user?.bio?.spin ? <Input disabled value={user.bio.spin} className="w-full" name="spin" /> : <Input name="spin" pattern="[0-9]{4}-[0-9]{4}" placeholder="0000-0000" className="w-full" />}
        </FormField>
      </div>
      <FormField name="ORCID" required={!skipOrcid}>
        <div className="flex flex-col gap-1">
          {user?.bio?.orcid ? <Input disabled value={user?.bio?.orcid} className="w-full" name="orcid" /> : <>
            <Input disabled={skipOrcid} placeholder="0000-0000-0000-0000" pattern="[0-9]{4}-[0-9]{4}-[0-9]{4}-[0-9]{4}" name="orcid" className="w-full" required={!skipOrcid} />
            <label>
              <input type="checkbox" checked={skipOrcid} onChange={e => setSkipOrcid(e.target.checked)} name="skip_orcid" />
              <span className="ml-0.5">У меня отсутствует ORCID </span>
            </label>
          </>}
        </div>
      </FormField>
      <FormField name="Последние публикации, соответствующие выбранным сферам экспертизы" required>
        <ErrorWrapper error={errors['publications']}>
          <div className="flex flex-col gap-1">
            {publications.map((v, idx) => <div key={idx} className="flex flex-row items-center gap-1">
              <Input value={v} setValue={nv => {
                const tmp = [...publications]
                tmp[idx] = nv
                setPublications(tmp)
              }} placeholder="http://" type="url" className="w-full" required />
              <button onClick={e => {
                e.preventDefault()
                const tmp = [...publications]
                tmp.splice(idx, 1)
                setPublications(tmp)
              }}>
                <img src="/images/remove-red.svg" width={24} height={24} className="w-1 h-1" />
              </button>
            </div>)}
            <button className="flex flex-row items-center justify-center border w-full rounded-lg p-0.5 border-dashed border-grey" onClick={e => {
              e.preventDefault()
              setPublications(p => [...p, ''])
            }}>
              <img src="/images/add-grey.svg" width={24} height={24} className="w-1 h-1" />
            </button>
          </div>
        </ErrorWrapper>
      </FormField>
      {/* <div className="flex flex-col gap-0.5"> */}
      <FormField name="Обработка персональных данных">
        <label>
          <input type="checkbox" checked={personalData} onChange={e => setPersonalData(e.target.checked)} name="consent" />
          <span className="ml-0.5">Даю согласие на обработку персональных данных</span>
        </label>
      </FormField>
      <ButtonV2 className="w-fit px-1" type="submit" disabled={!personalData}>Отправить</ButtonV2>
      {/* </div> */}
    </form>
  </div>
}


export default function Reviewers() {
  const [user] = useUser()

  const handleVerificationFormSubmit = useMutation({
    mutationFn: async (d: VerificationFormPayload) => {

      await handleFetchError(fetch(VERIFICATION_FORM_ENDPOINT, {
        method: 'POST',
        body: JSON.stringify(d),
      }))
    },
    onSuccess: async () => {
      toast.success('Ваша заявка отправлена на рассмотрение')
    },
    onError: async () => {
      toast.error(genericToastErrorMessage)
    }
  })
  return <>
    <Head>
    </Head>
    <Navbar user={user} static />
    <div className="flex flex-col gap-5 items-center px-4 max-2xl:px-2 pt-2">
      {/* <h1 className="font-bold text-6xl mt-3 mb-1 w-[1500px]">Сервисы</h1> */}
      <div className="rounded-lg flex flex-col items-start w-full gap-2 px-4 mt-3">
        <h1 className="text-4xl font-semibold leading-tight">Преимущества для&nbsp;рецензентов на платформе <span className="text-secondary">Research Helper</span></h1>
        <p className="text-xl">
          В&nbsp;<span className="text-secondary font-semibold">Research Helper</span> мы ценим вклад каждого рецензента в&nbsp;научное сообщество.<br />
          Предлагаем Вам удобные инструменты и&nbsp;возможности для&nbsp;улучшения качества научной экспертизы.
        </p>
      </div>
      {/* <div className="flex flex-row flex-wrap gap-1 gap-y-2.5"> */}
      <div className="flex flex-row flex-wrap gap-2 max-2xl:gap-y-4 px-4">
        <Benefit name="Шаблоны рецензий" icon="/images/info/template.svg">
          Используйте наши стандартизированные шаблоны для&nbsp;оформления ваших экспертных заключений, экономя время и&nbsp;усилия
        </Benefit>
        <Benefit name="Поиск и&nbsp;подбор рекомендуемой литературы" icon="/images/info/search.svg">
          Наша система предложит оптимальные источники для&nbsp;поддержания ваших заключений научными данными
        </Benefit>
        <span className="w-full max-2xl:hidden"></span>
        <Benefit name="Формирование и&nbsp;отправка рецензии в&nbsp;редакцию" icon="/images/info/direct-review.svg">
          Упростите процесс рецензирования с&nbsp;возможностью напрямую отправлять отзывы в&nbsp;журналы
        </Benefit>
        <Benefit name="Централизованное хранение информации" icon="/images/info/centralized-storage.svg">
          Все ваши запросы и&nbsp;рецензии будут удобно храниться в&nbsp;одном месте на&nbsp;нашей платформе
        </Benefit>
        <span className="w-full max-2xl:hidden"></span>
        <Benefit name="Бонусные баллы за&nbsp;работу" icon="/images/info/growth.svg">
          За&nbsp;каждую рецензию вы&nbsp;будете получать баллы, которые&nbsp;можно обменять на&nbsp;приоритетную публикацию ваших собственных статей в&nbsp;журналах, доступных на&nbsp;платформе
        </Benefit>
      </div>
      <div className="flex w-full justify-start pl-4">
        <VerificationForm onSubmit={d => handleVerificationFormSubmit.mutate(d)} user={user} />
      </div>
      <div className="h-2">
      </div>
    </div>
    <Footer />
  </>
}
